import { message } from "antd";
import { fetchTrainingGroup } from "PlatForms/OrgLMS/Services/LearnerService/trainingGroupService";
import { useState, useEffect } from "react";

const useTrainingGroup = () => {
  const learnerId = localStorage.getItem("personalId");
  const token = localStorage.getItem("token");
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [groupData, setGroupData] = useState([]);

  useEffect(() => {
    fetchGroupsData();
  }, []);

  const fetchGroupsData = async () => {
    setLoadingGroups(true);
    try {
      const data = await fetchTrainingGroup(learnerId, token);
      setGroupData(data);
    } catch (error) {
      message.error(error.message);
    }
    setLoadingGroups(false);
  };

  return {
    loadingGroups,
    groupData,
  };
};

export default useTrainingGroup;
